const features = {
    MULTI_SIZE_CREATIVE: 'multi_size_creative',
    BYNDER_DAM_ASSETS: 'bynder_dam_assets',
    INTERNAL_ASSET: 'internal_asset',
    MULTI_VARIATION: 'multi_variation',
    IMAGES_ENABLED: 'images_enabled',
    VIDEOS_ENABLED: 'videos_enabled',
    MULTI_VARIATION_NO_LIMIT: 'multi_variation_no_limit',
    GALLERY_ENABLED: 'gallery_enabled',
    APPROVALS_ENABLED: 'approvals_enabled',
    UCV_DERIVATIVES: 'ucv_derivatives',
    UCV_LIMITED: 'ucv_limited',
    CONTENT_PROPERTIES: 'content_properties',
    AI_VARIATIONS_TRANSLATE: 'ai_variations_translate',
    PDF: 'pdf_enabled',
    BULK_EXPORT: 'bulk_export',
    PRINT_PDF: 'print_pdf',
    MULTIPLE_SELECTION_MOVE_POC: 'multiple_selection_move_poc',
    CC_TEXT_ALIGNMENTS: 'cc_text_alignments',
    NEW_AUDIO_ELEMENT: 'new_audio_element',
    EDIT_WITH_AI: 'edit_with_ai',
    BYNDER_WAITING_ROOM_UPLOAD: 'bynder_waiting_room_upload',
    GROUP_ROTATION: 'group_rotation',
    UNIVERSAL_BRAND_COLOR_UPDATE: 'universal_brand_color_update_ff',
    MULTI_SELECTION_EDITING: 'multi_selection_editing',
    COMPONENT_GALLERY: 'component_gallery',
};

export default features;
